import { BuiltinAtoms } from '@lemon8/web-app-shared/atom';
import {
  $BannerInfo,
  $LegalRegion,
  $LegalLocation,
  $LegalEnterTraffic,
  $LegalCurrentTraffic,
} from 'shared/atoms/common';
import { $EmailData, $EmailPreference } from 'shared/atoms/email';

export const HydrationAtomsMap = {
  $LegalRegion,
  $LegalLocation,
  $EmailData,
  $BannerInfo,
  $EmailPreference,
  $LegalEnterTraffic,
  $LegalCurrentTraffic,
};

export const HydrationAtomFamiliesMap = {};

export const Atoms = {
  ...BuiltinAtoms,
  ...HydrationAtomsMap,
  ...HydrationAtomFamiliesMap,
};

export * from './common';
export * from './email';
